import { Component, HostBinding, ViewEncapsulation } from '@angular/core';

import { DynamicLayoutService } from '@frontend/vanilla/core';

import { CountQuickLinksComponent as msCountQuickLinksComponent } from '../../../../lib/quick-links/count-quick-links/count-quick-links.component';
import { COUNT_QUICKLINKS } from '../../../../lib/quick-links/quick-links.bootstrap';

@Component({
    selector: 'bs-digital-count-quick-links',
    template: '<vn-dynamic-layout-slot [slot]="slotCountQuickLinks" />',
    encapsulation: ViewEncapsulation.Emulated,
    styles: [
        `
            .betslip-count-quick-links .list-item {
                border-bottom: 1px solid var(--betslip-border-color);
            }
        `,
    ],
    standalone: false,
})
export default class CountQuickLinksComponent {
    readonly slotCountQuickLinks = COUNT_QUICKLINKS;
    @HostBinding('class') className = 'betslip-count-quick-links';
    constructor(private slot: DynamicLayoutService) {
        this.slot.setComponent(this.slotCountQuickLinks, msCountQuickLinksComponent, {});
    }
}
